import SectionTitle from './sectionTitle'

export default SectionTitle